import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as navbarActions from '../../actions/components/navbar'
import * as switchLocaleActions from '../../actions/components/intl'
import * as getCommoditiesAction from '../../actions/components/menu'
import * as updateSearchModeDisplayAction from '../../actions/components/categorydetaillist'
import * as completeTakeawayOrderAction from '../../actions/components/basket'
import * as stepperActions from '../../actions/components/stepper'
import { injectIntl } from 'react-intl'
import NavBar from '../../components/NavBar'
import * as userActions from '../../actions/components/user'

const mapStateToProps = (state) => {
  return {
    user: state.user,
    form: state.form,
    merchant: state.merchant,
    isTakeaway: state.basket.isTakeaway,
    categories: state.categories,
    query: state.query,
  }
}
const mapDispatchToProps = (dispatch) => {
  const { switchRightSideBar } = bindActionCreators(navbarActions, dispatch)
  const { switchLocale, setUserLocale } = bindActionCreators(switchLocaleActions, dispatch)
  const { getCommodities } = bindActionCreators(getCommoditiesAction, dispatch)
  const { updateSearchModeDisplay } = bindActionCreators(updateSearchModeDisplayAction, dispatch)
  const { completeTakeawayOrder } = bindActionCreators(completeTakeawayOrderAction, dispatch)
  const { updateNavBarSwiperExpand } = bindActionCreators(stepperActions, dispatch)
  return {
    switchRightSideBar,
    switchLocale,
    setUserLocale,
    getCommodities,
    updateSearchModeDisplay,
    completeTakeawayOrder,
    updateNavBarSwiperExpand,
    ...bindActionCreators(userActions, dispatch),
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(NavBar)))



// WEBPACK FOOTER //
// ./src/containers/components/NavBar.js